import { useState, useEffect } from 'react';
import { Card, CardBody, Col, Container, Row, Spinner, Badge } from 'reactstrap'
import { H5 } from '../../../../AbstractElements'
import { dynamicImage } from '../../../../Service'
import { Link } from 'react-router-dom'
import { Users, UsersCards } from '../../../../utils/Constant'
import SocialMediaIcons from './SocialMediaIcons'
import UserCardsFooter from './UserCardsFooter'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs'
import UserService from '../../../../Api/services/user.service'
import { useAuth } from '../../../../hooks/useAuth'
import { toast } from 'react-toastify'
import type { components } from '../../../../Api/types/openapi'

type UserSimpleResponse = components['schemas']['UserSimpleResponse'];

const UserCardsContainer = () => {
  const { hasRole } = useAuth();
  const [users, setUsers] = useState<UserSimpleResponse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [imageErrors, setImageErrors] = useState<{ [key: number]: boolean }>({});

  useEffect(() => {
    const loadUsers = async () => {
      try {
        setIsLoading(true);
        // Si es admin, cargar todos los usuarios, si no, solo el usuario actual
        const allUsers = await UserService.getUsers({ limit: 100 });
        setUsers(allUsers || []);
      } catch (error: any) {
        console.error('Error al cargar usuarios:', error);
        toast.error('Error al cargar usuarios');
      } finally {
        setIsLoading(false);
      }
    };

    loadUsers();
  }, []);

  const handleImageError = (userId: number) => {
    setImageErrors((prev) => ({ ...prev, [userId]: true }));
  };

  if (isLoading) {
    return (
      <>
        <Breadcrumbs mainTitle={UsersCards} parent={Users} />
        <Container fluid>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            <Spinner color="primary" />
          </div>
        </Container>
      </>
    );
  }

  if (users.length === 0) {
    return (
      <>
        <Breadcrumbs mainTitle={UsersCards} parent={Users} />
        <Container fluid>
          <div className="text-center p-5">
            <p>No hay usuarios para mostrar</p>
          </div>
        </Container>
      </>
    );
  }

  return (
    <>
      <Breadcrumbs mainTitle={UsersCards} parent={Users} />
      <Container fluid>
        <Row className="user-cards-items user-card-wrapper">
          {users.map((user) => {
            const defaultImage = dynamicImage("user/7.jpg");
            const userPhoto = (user.photo_url && !imageErrors[user.id]) ? user.photo_url : defaultImage;
            const userName = user.name || user.email || 'Usuario';
            const userEmail = user.email || 'Sin email';
            const userRole = user.role?.name || 'Usuario';

            return (
              <Col xl="4" sm="6" xxl="3" className="col-ed-4 box-col-4" key={user.id}>
                <Card className="social-profile">
                  <CardBody>
                    <div className="social-img-wrap">
                      <div className="social-img">
                        <img
                          src={userPhoto}
                          className="img-fluid"
                          alt={userName}
                          onError={() => handleImageError(user.id)}
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                      <div className="edit-icon">
                        {user.active ? (
                          <i className="fa fa-check-circle text-success" title="Usuario activo"></i>
                        ) : (
                          <i className="fa fa-times-circle text-danger" title="Usuario inactivo"></i>
                        )}
                      </div>
                    </div>
                    <div className="social-details">
                      <H5 className="mb-1">
                        <Link to={`${process.env.PUBLIC_URL}/users/userprofile`}>{userName}</Link>
                      </H5>
                      <span className="f-light d-block mb-2">{userEmail}</span>
                      {user.role && (
                        <Badge color="primary" className="mb-2">
                          {userRole}
                        </Badge>
                      )}
                      <SocialMediaIcons listClassName="card-social" />
                      <UserCardsFooter 
                        item={{
                          id: user.id,
                          avatar: userPhoto,
                          icon: user.active ? 'check-circle' : 'times-circle',
                          name: userName,
                          email: userEmail,
                          follower: user.active ? 'Activo' : 'Inactivo',
                          following: user.role?.name || 'N/A',
                          totalPost: user.email || 'N/A'
                        }} 
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  )
}

export default UserCardsContainer